import qcAutoOnlineStore from "../store/qcAutoOnline";


// Custom hook để sử dụng và cập nhật cấu hình player
const useQcAutoOnline = (playerId) => {
    const qcAutos = qcAutoOnlineStore((state) => state.qcAutos);
    const setqcAuto = qcAutoOnlineStore((state) => state.setqcAuto);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        qcAuto: playerId == null ? false : qcAutos[playerId] ?? false, // Nếu không có playerId, trả về object rỗng
        qcAutos,
        setqcAuto,
    };
};

export default useQcAutoOnline;
